import bus from "./bus";
import config from "./config";
import echarts from "echarts";
import {
  formatDate
} from "./parseTime";
import {
  drawerLine
} from "./chartsLine";
import {
  drawerBar
} from "./chartsBar";
import {
  drawerPie
} from "./chartsPie";
import {
  str
} from "./str";

const custom = {
  bus,
  formatDate,
  config,
  echarts,
  drawerLine,
  drawerBar,
  drawerPie,
  str
};

export default custom;



// WEBPACK FOOTER //
// ./src/util/custom.js